import chatService from './chatService'

export default chatService



// WEBPACK FOOTER //
// ../src/services/chatService/index.js